"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _global = _interopRequireDefault(require("global"));
var _newComponents = require("../../new-components");
var _ConfirmModal = _interopRequireDefault(require("./ConfirmModal"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ApplePaySession = _global["default"] && _global["default"].ApplePaySession;
var ApplePay = function ApplePay(_ref) {
  var amex = _ref.amex,
    visa = _ref.visa,
    mastercard = _ref.mastercard,
    currency = _ref.currency,
    product = _ref.product,
    apiKey = _ref.apiKey,
    paidAmount = _ref.paidAmount,
    onSuccess = _ref.onSuccess,
    applePayMerchantId = _ref.applePayMerchantId,
    checkoutTokenApi = _ref.checkoutTokenApi,
    setIsApplePayActive = _ref.setIsApplePayActive,
    isApplePayActive = _ref.isApplePayActive,
    handlePaymentValues = _ref.handlePaymentValues,
    girls = _ref.girls,
    guys = _ref.guys,
    baseUrl = _ref.baseUrl,
    minAge = _ref.minAge,
    companyId = _ref.companyId,
    travelInsuranceCheckBox = _ref.travelInsuranceCheckBox,
    weekTerms = _ref.weekTerms,
    destinationId = _ref.destinationId,
    scheduledPayments = _ref.scheduledPayments;
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    checkoutToken = _useState2[0],
    setCheckoutToken = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    scheme = _useState4[0],
    setScheme = _useState4[1];
  (0, _react.useEffect)(function () {
    if (ApplePaySession) {
      // this method is checking if your device supports Apple Pay and if you have active payment card on it
      ApplePaySession.canMakePaymentsWithActiveCard(applePayMerchantId).then(function (res) {
        return res && setIsApplePayActive(true);
      })["catch"](function (err) {
        return console.error(err);
      });
    }
  }, []);
  var onClick = function onClick() {
    var supportedNetworks = [];
    if (visa) supportedNetworks.push('visa');
    if (mastercard) supportedNetworks.push('masterCard');
    if (amex) supportedNetworks.push('amex');
    var applePaySession = new ApplePaySession(6, {
      countryCode: 'GB',
      currencyCode: currency,
      supportedNetworks: supportedNetworks,
      merchantCapabilities: ['supports3DS'],
      total: {
        label: product,
        amount: paidAmount / 100
      }
    });
    applePaySession.begin();
    applePaySession.onvalidatemerchant = function (e) {
      var validationUrl = e.validationURL;
      validateTheSession(validationUrl, function (merchantSession) {
        applePaySession.completeMerchantValidation(merchantSession);
      });
    };
    applePaySession.onpaymentauthorized = function (e) {
      // maybe here we can get 'scheme' to pass properly
      var applePaymentToken = e.payment.token;
      pay(applePaymentToken, function (data) {
        var card_type = data.card_type,
          scheme = data.scheme,
          token = data.token,
          last4 = data.last4,
          expiry_month = data.expiry_month,
          expiry_year = data.expiry_year,
          issuer_country = data.issuer_country;
        if (token) {
          setCheckoutToken(token);
          setScheme(scheme);
          handlePaymentValues(card_type, scheme, token, last4, expiry_month, expiry_year, issuer_country);
          applePaySession.completePayment(ApplePaySession.STATUS_SUCCESS);
        } else {
          applePaySession.completePayment(ApplePaySession.STATUS_FAILURE);
          setCheckoutToken(null);
          setScheme(null);
        }
      });
    };
  };
  var validateTheSession = function validateTheSession(validationUrl, callback) {
    // here we send validation url to backend
    fetch("/api/payment/validate-apple-pay-session".concat(companyId ? "?companyId=".concat(companyId) : ''), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        validationUrl: validationUrl,
        displayName: product
      })
    }).then(function (response) {
      return response.json();
    }).then(function (res) {
      return callback(JSON.parse(res.data));
    })["catch"](function (ex) {
      return console.error('Failed validating session', ex);
    });
  };
  var pay = function pay(applePaymentToken, callback) {
    if (!applePaymentToken) {
      return null;
    }
    var _applePaymentToken$pa = applePaymentToken.paymentData,
      version = _applePaymentToken$pa.version,
      data = _applePaymentToken$pa.data,
      signature = _applePaymentToken$pa.signature,
      header = _applePaymentToken$pa.header;
    fetch(checkoutTokenApi, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: apiKey
      },
      body: JSON.stringify({
        type: 'applepay',
        token_data: {
          version: version,
          data: data,
          signature: signature,
          header: header
        }
      })
    }).then(function (response) {
      return response.json();
    }).then(function (data) {
      return callback(data);
    })["catch"](function (ex) {
      return console.error('Failed payment', ex);
    });
  };
  if (!isApplePayActive) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_newComponents.Button, {
    onClick: onClick,
    buttonType: _newComponents.BUTTON_TYPES.APPLE_PAY,
    fullWidth: true
  }));
};
ApplePay.propTypes = {
  amex: _propTypes["default"].bool,
  visa: _propTypes["default"].bool,
  mastercard: _propTypes["default"].bool,
  currency: _propTypes["default"].string.isRequired,
  product: _propTypes["default"].string.isRequired,
  apiKey: _propTypes["default"].string.isRequired,
  paidAmount: _propTypes["default"].number.isRequired,
  onSuccess: _propTypes["default"].func.isRequired,
  applePayMerchantId: _propTypes["default"].string.isRequired,
  checkoutTokenApi: _propTypes["default"].string.isRequired,
  handlePaymentValues: _propTypes["default"].func.isRequired,
  setIsApplePayActive: _propTypes["default"].func.isRequired,
  isApplePayActive: _propTypes["default"].bool.isRequired,
  girls: _propTypes["default"].string,
  guys: _propTypes["default"].string,
  baseUrl: _propTypes["default"].string.isRequired,
  minAge: _propTypes["default"].number,
  companyId: _propTypes["default"].number,
  weekTerms: _propTypes["default"].string,
  destinationId: _propTypes["default"].number,
  scheduledPayments: _propTypes["default"].array,
  travelInsuranceCheckBox: _propTypes["default"].bool
};
var _default = exports["default"] = ApplePay;